export default "__VITE_ASSET__nAeAv86X__ 600w";